import IconButton from '@mui/material/IconButton'

// ** Icons Imports
import WeatherNight from 'mdi-material-ui/WeatherNight'
import WeatherSunny from 'mdi-material-ui/WeatherSunny'

const ModeToggler = props => {
  // ** Props
  const { settings, saveSettings } = props

  const handleModeChange = mode => {
    saveSettings({ ...settings, mode })
  }

  const handleModeToggle = () => {
    const authUserJSON = localStorage.getItem('authUser');
    let authUser = JSON.parse(authUserJSON);

    if (settings.mode === 'light') {
      handleModeChange('dark')
      authUser.themeMode = 'dark'
    } else {
      handleModeChange('light')
      authUser.themeMode = 'light'
    }

    localStorage.setItem('authUser', JSON.stringify(authUser));
  }

  return (
    <IconButton color='inherit' aria-haspopup='true' onClick={handleModeToggle}>
      {settings.mode === 'dark' ? <WeatherSunny /> : <WeatherNight />}
    </IconButton>
  )
}

export default ModeToggler
